export default "__VITE_ASSET__Dyk6UR6K__"